import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PAGES, PageType } from "@/app/navigation/navigation.constant";

type NavigationState = {
  activePage: PageType;
  selectedRequestId: string | null;
  techConversationTopic: string | null;
};

const initialState: NavigationState = {
  activePage: PAGES.AGENTS,
  selectedRequestId: null,
  techConversationTopic: null,
};

const navigationSlice = createSlice({
  name: "navigation",
  initialState,
  reducers: {
    goTo(state, action: PayloadAction<PageType>) {
      state.activePage = action.payload;
    },
    setSelectedRequestId(state, action: PayloadAction<string | null>) {
      state.selectedRequestId = action.payload;
    },
    setTechConversationTopic(state, action: PayloadAction<string | null>) {
      state.techConversationTopic = action.payload;
    },
  },
});

export const {
  goTo,
  setSelectedRequestId,
  setTechConversationTopic,
} = navigationSlice.actions;

export default navigationSlice.reducer;


